<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout column fill-height>
      <v-toolbar color="secondary" dense>
        <v-toolbar-title>
          <span class="body-1 uppercase white--text">{{ $t('Task') }} {{ data.id }}</span>
        </v-toolbar-title>
        <v-layout fill-height justify-end>
          <v-tooltip dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" icon flat slot="activator" @click="$emit('close')">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
        </v-layout>
      </v-toolbar>

      <scroll-table
        :data="getTable"
        :options="options"
        :sortable="false"
        :translate="true"
        :subscribed="true"
        :hideValues="['undefined']"
        @select=""
      />
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import tamd from '@/nms/components/modal/components/tasksArchModalDescriptor.js'
import trmd from '@/nms/components/modal/components/tasksRealModalDescriptor.js'

// Типы для данных
interface TaskProgressItem {
  $id?: string
  message?: string
  status?: string
  processing?: string
  [key: string]: any
}

interface TaskData {
  progress?: TaskProgressItem[]
  data?: string | any
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableRow {
  message?: string
  status?: string
  processing?: string
  $id?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

export default Vue.extend({
  name: 'TASKS_MODAL',

  components: {
    scrollTable,
    loadingCircle,
  },

  props: {
    data: {
      type: Object as () => TaskData,
      default: () => ({})
    },
    mode: {
      type: String,
      default: () => ''
    },
  },

  data(): {
    loader: boolean
    options: OptionsData
    filter: any | null
    search: string
    table: TableData
  } {
    return {
      loader: false,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      },
      filter: null,
      search: '',
      table: {
        columns: [
          {
            title: 'message',
            value: 'message',
            type: 'text',
            width: '40%'
          },
          {
            title: 'status',
            value: 'status',
            type: 'text',
            width: '30%'
          },
          {
            title: 'description',
            value: 'processing',
            type: 'text',
            width: '30%'
          },
        ],
        rows: []
      },
    }
  },

  computed: {
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      return t
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      console.log(this.$options.name, 'statusSubscribe', 'data', this.data)
      console.log(this.$options.name, 'statusSubscribe', 'mode', this.mode)
      this.reset()
      this.statusUnsubscribe('TASKS_MODAL')
      this.prepareTable()
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async prepareTable(): Promise<void> {
      try {
        // Режим realtime
        if (this.mode === 'realtime') {
          this.table.columns = trmd.columns
          
          if (!this.data.progress?.length) return
          
          this.loader = true
          this.data.progress.forEach((status: TaskProgressItem) => {
            this.table.rows.push(status)
          })
          
          console.log(this.$options.name, 'prepareTable', 'this.table', this.table)
          this.loader = false
          this.statusSubscribe(this.table.rows, 'TASKS_MODAL')
        }
        
        // Режим archive
        if (this.mode === 'archive') {
          this.table.columns = tamd.columns
          console.log(this.$options.name, 'ARCHIVE ID', this.data)
          console.log(this.$options.name, 'ARCHIVE type', typeof this.data.data)
          
          if (this.data.data && typeof this.data.data === 'string') {
            const d = JSON.parse(this.data.data)
            if (d.progress) {
              this.table.rows = d.progress
            }
          } else if (this.data.data && typeof this.data.data === 'object') {
            this.table.rows.push(this.data.data)
          }
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }
    },

    async statusSubscribe(arr: TableRow[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      
      if (arr.length) {
        arr.forEach((item: TableRow) => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset(): void {
      this.table.columns = []
      this.table.rows = []
    }
  }
})
</script>

<style scoped lang="less">

</style>
